import classnames from 'classnames';
import { GROUND_TRIP_ASSIGNMENT_STATUSES } from '@lp/features/RoutePlanner/config';
import { AoAssignmentStatus, DriverAssignmentStatus } from '@/api/apis/drive-service';

const STATUS_CHIP_COLOR_BY_TYPE: Record<DriverAssignmentStatus | AoAssignmentStatus, string> = {
  [DriverAssignmentStatus.WaitingForAoApproval]: 'bg-base-50',
  [DriverAssignmentStatus.PendingDriverAssignment]: 'bg-base-50',
  [DriverAssignmentStatus.PendingDriverApproval]: 'bg-base-50',
  [DriverAssignmentStatus.DriverApproved]: 'bg-success-50',
  [DriverAssignmentStatus.DriverRejected]: 'bg-danger-30',
  [AoAssignmentStatus.NoAoReview]: 'bg-base-50',
  [AoAssignmentStatus.PendingAoApproval]: 'bg-base-50',
  [AoAssignmentStatus.AoApproved]: 'bg-success-50',
  [AoAssignmentStatus.AoRejected]: 'bg-danger-30',
};

type TripAssignmentStatusChipProps = {
  status: DriverAssignmentStatus | AoAssignmentStatus;
};

export const TripAssignmentStatusChip = ({ status }: TripAssignmentStatusChipProps) => {
  const statusBgClass = STATUS_CHIP_COLOR_BY_TYPE[status];
  const statusTitle = GROUND_TRIP_ASSIGNMENT_STATUSES[status];

  return (
    <div className="flex gap-1 items-center px-1 py-0 rounded-lg bg-white w-fit">
      <div className={classnames('w-2 h-2 rounded-full', statusBgClass)} />
      <span className="text-s-r text-base-5">{statusTitle}</span>
    </div>
  );
};
